export default "__VITE_ASSET__PeQQkEwi__"